<div class="blog">

  <iframe [src]="blogUrl" #iframe_div></iframe>

</div>
